/**
 * Bot / crawler User-Agent detection.
 *
 * Used by AgeVerification.jsx to suppress the age-gate modal for search
 * engine and AI crawler bots so Google's URL Inspection Tool doesn't
 * classify product pages as Soft 404. Bots cannot click "Confirm" on the
 * modal — without this exemption, Googlebot's JS-rendered view shows the
 * modal as the dominant visible element and the page appears to gate all
 * content behind a required interaction.
 *
 * This is NOT cloaking. Bots receive the same final content humans see
 * after the one confirmation click.
 *
 * Keep this list in sync with /app/frontend/public/robots.txt allowlist.
 */
const CRAWLER_UA_PATTERN = /googlebot|google[- ]inspection|google[- ]read[- ]aloud|bingbot|bing-?preview|slurp|duckduckbot|duckassistbot|baiduspider|yandexbot|sogou|exabot|facebot|ia_archiver|gptbot|chatgpt-user|oai-?searchbot|claude-?web|claudebot|anthropic-?ai|perplexitybot|youbot|cohere-?ai|meta-externalagent|applebot|mojeekbot|petalbot|seznambot|ccbot|mistralai/i;

export const isCrawlerUA = (ua) => {
  if (!ua || typeof ua !== 'string') return false;
  return CRAWLER_UA_PATTERN.test(ua);
};
